"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _reactstrap = require("reactstrap");

var _lodash = require("lodash");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var logo = require("./images/aculist-edge_logo.png");
var iic = require("./images/inventory-count.svg");
var isc = require("./images/sold-count.svg");
var idom = require("./images/med-dom.svg");

// import numeral from "numeral";

var KPIWidget = function (_Component) {
  _inherits(KPIWidget, _Component);

  function KPIWidget() {
    _classCallCheck(this, KPIWidget);

    return _possibleConstructorReturn(this, (KPIWidget.__proto__ || Object.getPrototypeOf(KPIWidget)).apply(this, arguments));
  }

  _createClass(KPIWidget, [{
    key: "render",
    value: function render() {
      var props = this.props;

      var _props$widgetselectio = _extends({}, props.widgetselections),
          measure = _props$widgetselectio.measure,
          geographytype = _props$widgetselectio.geographytype,
          geographyvalue = _props$widgetselectio.geographyvalue,
          measurelabel = _props$widgetselectio.measurelabel,
          measuredata = _props$widgetselectio.measuredata;

      var title = props.title;
      var gt = geographytype.toLowerCase();
      var disclaimer = "Statistics based on sales over the last 30 days";
      var imageSrc = '';
      var widgetTitle = '';
      var measurelabelnew = measurelabel;
      widgetTitle = measurelabel;
      measurelabelnew = "";
      var ameasure = measure.toLowerCase();

      imageSrc = ameasure == "soldmeddom" ? "" + idom : ameasure == "inventorycount" ? "" + iic : ameasure == "soldcount" ? "" + isc : '';

      return _react2.default.createElement(
        _reactstrap.Card,
        { key: (0, _lodash.uniqueId)('kpiWidgetCard-'), className: "kpiWidget" },
        _react2.default.createElement(
          _reactstrap.CardBlock,
          { className: "kpiWidgetBody" },
          _react2.default.createElement(
            _reactstrap.Row,
            null,
            _react2.default.createElement(
              _reactstrap.Col,
              { className: "col-12 title-col" },
              _react2.default.createElement(
                _reactstrap.CardTitle,
                { className: "kpiWidgetTitle text-center font-weight-normal" },
                widgetTitle
              )
            ),
            _react2.default.createElement(
              _reactstrap.Row,
              { className: "kpiWidgetContent col-12 my-3 mx-1" },
              _react2.default.createElement(
                _reactstrap.Col,
                { sm: { size: 'auto' } },
                _react2.default.createElement(
                  _reactstrap.Media,
                  { middle: true },
                  _react2.default.createElement(_reactstrap.Media, { className: "mx-auto d-block kpiWidgetMedia", object: true, src: imageSrc })
                )
              ),
              _react2.default.createElement(
                _reactstrap.Col,
                { sm: { size: 'auto' } },
                _react2.default.createElement(
                  _reactstrap.CardTitle,
                  { className: "font-weight-bold text-center kpiMeasure" },
                  measuredata
                )
              )
            )
          )
        )
      );
    }
  }]);

  return KPIWidget;
}(_react.Component);

exports.default = KPIWidget;
module.exports = exports["default"];


//////////////////
// WEBPACK FOOTER
// ./~/react-aculistkpiwidget/lib/kpiwidget.js
// module id = 214
// module chunks = 0